import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
	cs: {
		weekdays: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
		months: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
	}
};

@Injectable()
export class SmNgbDatepickerI18n extends NgbDatepickerI18n {
	getWeekdayShortName(weekday: number): string {
		return I18N_VALUES['cs'].weekdays[weekday - 1];
	}
	getMonthShortName(month: number): string {
		return I18N_VALUES['cs'].months[month - 1];
	}
	getMonthFullName(month: number): string {
		return this.getMonthShortName(month);
	}
	getDayAriaLabel(date: NgbDateStruct): string {
		return '';
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/sm-ngb-datepicker-i18n.ts